const calculateFileSize = () => {
    const fixed_size = Number(process.env.REACT_APP_DOCUMENT_FILE_SIZE);
    const size_in_mb = Number(fixed_size) / 1000000;
    return size_in_mb;
}

export const FILE_SIZE_LIMIT_EXCEEDED = `File size limit exceeded. Max file size should be ${calculateFileSize()} MB.`;


export const DOCUMENT_UPLOAD_LIMIT_FOR_INDIVIDUAL_DOC = `Only ${process.env.REACT_APP_DOCUMENT_UPLOAD_LIMIT} documents can be uploaded at a time.`;

export const FETCHING_APPLICANT_DETAILS = 'Please wait, while we are fetching applicant details.';

export const SUBMIT_CUSTOMER_DOCUMENTS = 'Please wait, while we are submitting your uploaded documents.';